// @flow

import { css } from 'styled-components';
import media from '../helpers/media';

export default css`
  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
    padding: 0;
  }

  body {
    margin: 0;
  }

  body.noscroll-sm {
    overflow-y: hidden;
    ${media.sm(css`
      overflow-y: auto;
    `)}
  }

  body.noscroll-md {
    overflow-y: hidden;
    ${media.md(css`
      overflow-y: auto;
    `)}
  }

  body.noscroll-lg {
    overflow-y: hidden;
    ${media.lg(css`
      overflow-y: auto;
    `)}
  }
`;
